module.exports = __webpack_public_path__ + "static/media/A (11).08baa6c2.jpg";